import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const SectionExamDownloadRequest = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const [month, setMonth] = useState(""); // ✅ Changed: Initialized as an empty string
    const [start_date, setStartDate] = useState(""); // ✅ Changed: Initialized as an empty string
    const [end_date, setEndDate] = useState("");
    const [exam_id, setExam_id] = useState("");
    const [examNameList, setExamNameList] = useState([]);
    const apiUrl = useRef(null);

    const [requestList, setRequestList] = useState([]);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getReDownloadRequestList();
    }, []);

    const handleMonth = async (newMonth) => {
        setMonth(newMonth ? newMonth.format('YYYY-MM') : '');
        setStartDate(newMonth.startOf('month').format('YYYY-MM-DD'));
        setEndDate(newMonth.endOf('month').format('YYYY-MM-DD'));

        await getExamMasterList(newMonth.startOf('month').format('YYYY-MM-DD'), newMonth.endOf('month').format('YYYY-MM-DD'))


        // if (newMonth.format('YYYY-MM').trim().length !== 0) {
        //     setError(prevErrors => prevErrors.filter(error => error.path[0] !== 'month'));
        // }
    };

    const handleExamChange = (e) => {
        const { name, value } = e.target;
        console.log({value})
        setExam_id(value);

        // if (value.trim().length !== 0) {
        //     setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        // }
    }

    const getExamMasterList = async (start_date, end_date) => {
        const apiUrl = `/assigned-exams?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`;

        try {
            const response = await authorizedAxiosSection.get(apiUrl);
            setExamNameList(response.data.data);
        } catch (error) {
            setExamNameList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    };

    const getApiUrl = () => {
        let apiUrl = `/get-student-exam-re-download-request?section_id=${sectionMasterId}&`;
        if (!exam_id && start_date && end_date) {
            apiUrl += `start_date=${start_date}&end_date=${end_date}&`;
        }

        if (exam_id !== "") {
            apiUrl += `exam_id=${exam_id}&`
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getReDownloadRequestList = () => {
        // const apiUrl = `/get-student-exam-re-download-request?section_id=${sectionMasterId}`;
        // const apiUrl = getApiUrl();
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl.current ? apiUrl.current : getApiUrl())
            .then(response => {
                setRequestList(response.data.data);
                apiUrl.current = null;
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleRequest = (id, downloadRequestStatus) => {
        const apiUrl = `/update-student-exam-re-download-request?id=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.patch(apiUrl, { downloadRequestStatus })
            .then(response => {
                getReDownloadRequestList();
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputReset = () => {
        setMonth("");
        setStartDate("");
        setEndDate("");
        setExam_id("");
        setExamNameList([]);
        setRequestList([]);
        apiUrl.current = `/get-student-exam-re-download-request?section_id=${sectionMasterId}`;
        getReDownloadRequestList();
    };

    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />

                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Exam Download Request</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-download"></i>Exam Download Request</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">

                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6 full_wrap">
                                                    <label for="inputPassword" className="col-form-label">{/*<span style={{ color: "red" }}>*</span>*/}Select Month</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(month)}
                                                            onChange={handleMonth}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="exam_id" className="col-form-label">{/*<span style={{ color: "red" }}>*</span>*/}Select Exam Name:</label>
                                                    <select class="form-select" aria-label="Default select example" name='exam_id' onChange={handleExamChange} value={exam_id}>
                                                        <option selected value={''} disabled>Select Exam</option>
                                                        {
                                                            examNameList?.map((exam) => {
                                                                return <option value={exam.ExamMaster.id}>{exam.ExamMaster.exam_name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    <button className="btn btn-primary" type="button" onClick={getReDownloadRequestList}>Show</button>
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="separator"></div>
                                        <div className="col-md-12">

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">

                                                    {
                                                        requestList.length > 0 ?
                                                            requestList.map((request) => (
                                                                <>
                                                                    {(request.downloadRequestStatus === 'P') && (
                                                                        <div className="alert alert-warning alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Pending:</strong> A student named {request.StudentMaster.studentName} has requested to Exam. Do you want to approve?
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                <div>No of Downloads: {request.downloadCount}</div>
                                                                                <div>No of Request: {request.downloadRequestCount}</div>
                                                                                {/* <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div> */}
                                                                            </div>
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-approve-custom mx-1"
                                                                                    aria-label="Approve"
                                                                                    onClick={() => handleRequest(request.id, 'A')}
                                                                                >
                                                                                    <i className="fas fa-check"></i>
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-reject-custom mx-1"
                                                                                    aria-label="Reject"
                                                                                    onClick={() => handleRequest(request.id, 'R')}
                                                                                >
                                                                                    <i className="fas fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>)}
                                                                    {(request.downloadRequestStatus === 'A') && (
                                                                        <div className="alert alert-success alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Approved:</strong> {request.StudentMaster.studentName} Exam request was approved.
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                {/* <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div> */}
                                                                            </div>
                                                                        </div>)}
                                                                    {(request.downloadRequestStatus === 'R') && (
                                                                        <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center p-3" role="alert" style={{ borderRadius: '10px' }}>
                                                                            <div className="flex-grow-1">
                                                                                <strong>Rejected:</strong> {request.StudentMaster.studentName} Exam request was rejected.
                                                                                <div>Exam Name: {request.ExamMaster.exam_name}</div>
                                                                                <div>Class Name: {request.InstituteGradeMaster.gradeName}</div>
                                                                                {/* <div>Division Name: {request.InstituteDivisionMaster.divisionName}</div> */}
                                                                            </div>
                                                                        </div>)}
                                                                </>
                                                            ))
                                                            :
                                                            <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                                <strong>No Request Available</strong>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionExamDownloadRequest

